import { PayloadAction } from "@reduxjs/toolkit";
import { ToolResultState } from "@/components/ToolsResultPage/redux/types";
import { ToolAttributes } from "@/components/ToolsPage/api/interface";

const ToolResultReducer = {
  setToolData: (state: ToolResultState, action: PayloadAction<ToolAttributes>) => {
    state.toolData = action.payload;
  },
  setToolResultContentData: (state: ToolResultState, action: PayloadAction<any>) => {
    state.content = action.payload;
  },
  setToolType: (state: ToolResultState, action: PayloadAction<string>) => {
    state.type = action.payload;
  },
  setToolSeo: (state: ToolResultState, action: PayloadAction<string>) => {
    state.seo = action.payload;
  },
};

export default ToolResultReducer;
